/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Grid, Paper, Typography, WithStyles } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { push } from "connected-react-router";
import * as React from "react";
import { connect } from "react-redux";

import { signIn, signUp, forgotPassword } from "../../store/actions";
import Background from "../../components/Background/Background";
import { FormLogin } from "../../components/FormLogin/FormLogin";
import { FormLostPassword } from "../../components/FormLostPassword/FormLostPassword";
import { FormRegister } from "../../components/FormRegister/FormRegister";
import { Logo } from "../../components/Logo/Logo";
import { RootState } from "../../types/RootState";
import { styles } from "./PageLogin.style";
import { compose } from "recompose";

interface PageLoginProps extends WithStyles<typeof styles> {
    mode: "login" | "register" | "lostPassword";
    signIn?: typeof signIn;
    signUp?: typeof signUp;
    forgotPassword?: typeof forgotPassword;
    push?: typeof push;
}
class PageLogin extends React.Component<PageLoginProps> {
    public render() {

        const { classes } = this.props;
        return (
            <Background>
                <Paper className={classes.container} elevation={4}>
                    <Grid container={true}>
                        <Grid item={true} xs={5} className={classes.left} >
                            <Logo size="small" />
                            <div className={classes.marginAuto} >
                                <div className={classes.title}>
                                    <Typography variant="headline" gutterBottom={true}>Bienvenue !</Typography>
                                </div>
                                <Typography variant="body1">
                                    Outil interne d’aide à la vente destiné aux commerciaux. Cet outil permet d’accompagner de façon globale la démarche du vendeur.
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item={true} xs={7} className={classes.form} >
                            <div className={classes.subtitle}>
                                <Typography variant="subheading" >Se connecter au simulateur prévoyance</Typography>
                            </div>
                            <div className={classes.marginAuto} >
                                {this._renderForm()}
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </Background>
        );
    }

    private _renderForm() {
        switch (this.props.mode) {
            case "lostPassword":
                return (
                    <FormLostPassword
                        onSubmit={(email) => this.props.forgotPassword({ email })}
                    />
                );
            case "register":
                return (
                    <FormRegister
                        onSubmit={(email, password) => this.props.signUp({ email, password })}
                    />
                );
            case "login":
            default:
                return (
                    <FormLogin
                        onLogin={(email, password) => this.props.signIn({ email, password })}
                        push={this.props.push}
                    />
                );

        }
    }
}

export const PageLoginConnected = compose(
    withStyles(styles),
    connect(
        (state: RootState, ownProps: PageLoginProps) => ({
            ...ownProps
        }),
        { signIn, signUp, push, forgotPassword }
    )
)(PageLogin);

// For stories
export const PageLoginStyled = withStyles(styles)(PageLogin);


// WEBPACK FOOTER //
// ./src/pages/PageLogin/PageLogin.tsx